var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.01 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.66,17a.7.7,0,0,1-.47-.19A.7.7,0,0,1,0,16.13l1.1-3.4a8.5,8.5,0,1,1,3.14,3.14L.87,17A.71.71,0,0,1,.66,17Zm3.69-2.52a.68.68,0,0,1,.35.1A7.15,7.15,0,1,0,2.41,12.3a.65.65,0,0,1,.07.56l-.79,2.45,2.46-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17,8.18A.59.59,0,0,1,8,8.18a.59.59,0,0,1,.59-.59h0A.59.59,0,0,1,9.17,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.55,8.18a.59.59,0,0,1-1.17,0A.59.59,0,0,1,12,7.59h0A.59.59,0,0,1,12.55,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79,8.18a.59.59,0,0,1-1.17,0,.59.59,0,0,1,.59-.59h0A.59.59,0,0,1,5.79,8.18Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c9cacd9aa9e7f10ea4255bc775b2721d.svg";
export { ForwardRef as ReactComponent };